import { GLOBAL_MEETING_SETTING_VALUE } from "types/meeting-settings.types";

export const getToggleState = (value: GLOBAL_MEETING_SETTING_VALUE) => {
  if (value === GLOBAL_MEETING_SETTING_VALUE.ON) return "on";
  if (value === GLOBAL_MEETING_SETTING_VALUE.PARTIAL) return "indeterminate";
  if (value === GLOBAL_MEETING_SETTING_VALUE.OFF) return "off";
  return "off";
};
